/** Formatters for values that come from the API and end up on screen. */

/**
 * Format an API timestamp without ever throwing.
 *
 * `Intl.DateTimeFormat.format(new Date(x))` raises `RangeError` when `x` does not parse,
 * and a raise inside render unmounts the whole screen: there is no error boundary above
 * the pages. A malformed `received_at` must cost the cell, not the page, so the raw
 * string is shown instead.
 */
export function formatDate(formatter: Intl.DateTimeFormat, value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return formatter.format(date);
}

/** A size for a human: bytes, whole KB, or MB, GB and TB with one decimal (the bucket
 * weighs gigabytes against a terabyte, contract v10.49). */
export function formatBytes(size: number): string {
  if (size < 1024) return `${size} B`;
  if (size < 1024 ** 2) return `${(size / 1024).toFixed(0)} KB`;
  if (size < 1024 ** 3) return `${(size / 1024 ** 2).toFixed(1)} MB`;
  if (size < 1024 ** 4) return `${(size / 1024 ** 3).toFixed(1)} GB`;
  return `${(size / 1024 ** 4).toFixed(1)} TB`;
}
